import { ComponentStyleConfig } from '@chakra-ui/react';

export const Tabs: ComponentStyleConfig = {
    baseStyle: {
        tabpanels: {
            borderRadius: 21
        }
    }
};
